@let form = capabilityForm();
@let toolForm = activeToolForm();

<glxy-page>
  <glxy-page-toolbar>
    <glxy-page-nav>
      @if (toolForm) {
        <ng-container *ngTemplateOutlet="fauxNavButton"></ng-container>
      } @else {
        <glxy-page-nav-button [useHistory]="true" previousPageUrl="../" [useRelativePath]="true"></glxy-page-nav-button>
      }
    </glxy-page-nav>
    <glxy-page-title>
      {{ 'AI_ASSISTANT.SETTINGS.CAPABILITY' | translate }}
      @if (toolForm) {
        <mat-icon aria-hidden="true">chevron_right</mat-icon>
        {{ 'AI_ASSISTANT.SETTINGS.TOOL' | translate }}
      }
    </glxy-page-title>
  </glxy-page-toolbar>

  @if (loading() || creatingForm()) {
    <glxy-loading-spinner></glxy-loading-spinner>
  } @else if (form) {
    @if (toolForm) {
      <glxy-page-wrapper>
        <ai-tool-form [form]="toolForm" class="tool-form" />
        <ai-sticky-footer
          (submitClick)="handleToolFormSubmit()"
          [submitOverride]="'AI_ASSISTANT.FUNCTIONS.EDIT_FUNCTION.DONE' | translate"
          (cancelClick)="closeToolForm()"
          [showUnsavedChangesIndicator]="toolForm.dirty"
        />
      </glxy-page-wrapper>
    } @else {
      <glxy-page-wrapper>
        @if (isGlobalOrManagedCapability()) {
          <glxy-alert type="warning">
            <strong>{{ 'AI_ASSISTANT.SETTINGS.GLOBAL_CAPABILITY_READ_ONLY_TITLE' | translate }}</strong>
            {{ 'AI_ASSISTANT.SETTINGS.GLOBAL_CAPABILITY_READ_ONLY_ENHANCED' | translate }}
          </glxy-alert>
        }
        <ai-capability-form
          [capabilityForm]="form"
          [disableConfigurableGoalFields]="true"
          class="capability-form"
          (toolFormDisplay)="handleToolFormDisplay($event)"
          [allowRemovingAnyTools]="!isGlobalOrManagedCapability()"
        />
        <ai-sticky-footer
          (submitClick)="handleCapabilityFormSubmit()"
          [submitOverride]="'AI_ASSISTANT.SHARED.SAVE' | translate"
          (cancelClick)="handleCancel()"
          [showUnsavedChangesIndicator]="form.dirty"
          [disabled]="isGlobalOrManagedCapability()"
        />
      </glxy-page-wrapper>
    }
  } @else if (capability() === null) {
    <glxy-page-wrapper>
      <div class="error-message">
        <p>{{ 'AI_ASSISTANT.SETTINGS.CAPABILITY_NOT_FOUND' | translate }}</p>
      </div>
    </glxy-page-wrapper>
  }
</glxy-page>

<!-- Faux nav button template -->
<ng-template #fauxNavButton>
  <button (click)="closeToolForm()" mat-icon-button>
    <mat-icon>arrow_back</mat-icon>
  </button>
</ng-template>
